let apiVersion: string | null = null
const listeners = new Set<() => void>()

export function setApiVersion(version: string) {
  if (apiVersion !== version) {
    apiVersion = version
    listeners.forEach((l) => l())
  }
}

export function getApiVersionSnapshot() {
  return apiVersion
}

export function subscribeApiVersion(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
